module.exports = __webpack_public_path__ + "fonts/bebasneuecyrillic.e8b9350b.ttf";